import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/admin/productos', icon: 'fas fa-box', label: 'Productos' },
    { path: '/admin/categorias', icon: 'fas fa-tags', label: 'Categorías' }
  ];

  return (
    <div className="admin-sidebar">
      <div className="sidebar-logo">
        <img
          src="/Logos/logo-sin-fondo.png"
          alt="Lumière Tica"
        />
      </div>

      <Nav className="flex-column sidebar-nav">
        {menuItems.map((item) => (
          <Nav.Link
            key={item.path}
            as={Link}
            to={item.path}
            className={`sidebar-nav-item ${location.pathname === item.path ? 'active' : ''} ${item.highlighted ? 'highlighted' : ''}`}
          >
            <i className={item.icon}></i>
            <span>{item.label}</span>
          </Nav.Link>
        ))}
      </Nav>
    </div>
  );
};

export default Sidebar;
